module.exports = __webpack_public_path__ + "img/search_04.4db0a4b4.png";